import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'last'
})
export class LastPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return null;
  }
}
